export const addressLinkStyles = {
	fontSize: '1.375rem',
	lineHeight: '1.625rem',
	paddingX: '0',
};

export const workingHoursBoxStyles = { paddingY: '2rem' };

export const workingHoursContainerStyles = { flexDirection: 'column', paddingTop: '0.5rem' };
